import { useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ViewOnlyContext } from '../context';

/**
 * Returns view-only flag and secret from URL when on a view-only event route.
 * Used by useEventDetails, useEventTodo, EventMapHeader, and any component that
 * needs to pass the secret to event queries for view-only access.
 */
export function useViewOnlySecret(): { viewOnly: boolean; secret: string | undefined } {
    const viewOnly = useContext(ViewOnlyContext);
    const [searchParams] = useSearchParams();
    const secret = viewOnly ? (searchParams.get('secret') ?? undefined) : undefined;
    return { viewOnly, secret };
}
